/* eslint react-hooks/exhaustive-deps: 0 */ // --> OFF

// TODO: Find the possibility to put all this scroll listener into a hook.

import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Frame, { FrameProps } from './Frame';
import { intersectionObserverInit } from './intersectionObservedIDs';

export const State: React.FC<FrameProps> = props => {
  const { id } = props;
  const componentID = id || uuidv4();
  const [isShowing, setIsShowing] = useState<boolean>(false);

  const handleEventCallback = (e: IntersectionObserverEntry[]) => {
    setIsShowing(e[0].isIntersecting);
  };

  const initializeObserver = (): IntersectionObserver => {
    const observer = new IntersectionObserver(
      handleEventCallback,
      intersectionObserverInit,
    );

    const element = window.document.getElementById(componentID);

    if (element) observer.observe(element);

    return observer;
  };

  const clearObserver = (observer?: IntersectionObserver) => {
    if (observer) observer.disconnect();
  };

  useEffect(() => {
    const observer = initializeObserver();

    return () => {
      clearObserver(observer);
    };
  }, []);

  return <Frame {...props} id={id || componentID} isShowing={isShowing} />;
};
